import React from 'react'
import { Route } from 'react-router-dom'
import DefaultLayout from './DefaultLayout'
import { Locations } from './Locations'
import PreTaxOverviewView from 'employee-platform/features/PreTax/PreTaxOverviewView'
import TripsOverviewView from 'employee-platform/features/Trips/TripsOverviewView'
import LeaderboardsOverviewView from 'employee-platform/features/Leaderboards/LeaderboardsOverviewView'
import CarpoolOverviewView from 'employee-platform/features/Carpool/CarpoolOverviewView'
import CarpoolDetailsView from 'employee-platform/features/Carpool/CarpoolDetailsView'
import CarpoolRequestDetailsView from 'employee-platform/features/Carpool/CarpoolRequestDetailsView'
import EmployeeDashboardView from 'employee-platform/features/Dashboard/Overview/EmployeeDashboardView'
import ProfileSettingsView from 'employee-platform/features/Profile/ProfileSettingsView'
import EmployeeConciergeView from 'employee-platform/features/Concierge/EmployeeConciergeView'
import AddTripView from 'employee-platform/features/Trips/AddTripView'
import EmployeeGRHOverviewView from 'employee-platform/features/GRH/EmployeeGRHOverviewView'
import StatusView from 'employee-platform/features/GRH/StatusView'
import EmployeeOptInOverviewView from 'employee-platform/features/OptIn/EmployeeOptInOverviewView'
import EmployeeFlexOverviewView from 'employee-platform/features/Flex/EmployeeFlexOverviewView'
import EmployeeMicromobilityOverviewView from 'employee-platform/features/Micromobility/EmployeeMicromobilityOverviewView'
import EmployeeMicromobilityCheckoutConfirmationView from 'employee-platform/features/Micromobility/EmployeeMicromobilityCheckoutConfirmationView'
import EmployeeTransactionsView from 'employee-platform/features/Transactions/EmployeeTransactionsView'
import ReimbursementView from 'employee-platform/features/Reimbursement/ReimbursementView'
import TransitPassOverviewView from 'employee-platform/features/TransitPass/TransitPassOverviewView'
import ReportedUsageView from 'employee-platform/features/ReportedUsage/ReportedUsageView'

const EmployeeRoutes = () => (
  <>
    <Route path={'/'} element={<DefaultLayout />}>
      {/* Employee Platform Routes */}
      <Route
        path={Locations.EmployeeDashboard}
        element={<EmployeeDashboardView />}
      />
      <Route
        path={Locations.EmployeeSettings}
        element={<ProfileSettingsView />}
      />
      <Route
        path={Locations.EmployeePreTax.Overview}
        element={<PreTaxOverviewView />}
      />
      <Route
        path={Locations.EmployeeCarpool.Overview}
        element={<CarpoolOverviewView />}
      />
      <Route
        path={Locations.EmployeeCarpool.CarpoolDetails}
        element={<CarpoolDetailsView />}
      />
      <Route
        path={Locations.EmployeeCarpool.CarpoolRequestDetails}
        element={<CarpoolRequestDetailsView />}
      />
      <Route
        path={Locations.EmployeeGRH.Overview}
        element={<EmployeeGRHOverviewView />}
      />
      <Route path={Locations.EmployeeGRH.Status} element={<StatusView />} />
      <Route
        path={Locations.EmployeeFlex.Overview}
        element={<EmployeeFlexOverviewView />}
      />
      <Route
        path={Locations.EmployeeMicromobility.Overview}
        element={<EmployeeMicromobilityOverviewView />}
      />
      <Route
        path={Locations.EmployeeMicromobility.CheckoutConfirmation}
        element={<EmployeeMicromobilityCheckoutConfirmationView />}
      />
      <Route
        path={Locations.EmployeeTransactions.Overview}
        element={<EmployeeTransactionsView />}
      />
      <Route
        path={Locations.EmployeeTrips.Overview}
        element={<TripsOverviewView />}
      />
      <Route path={Locations.EmployeeTrips.AddTrip} element={<AddTripView />} />
      <Route path={Locations.EmployeeTrips.EditTrip} element={<AddTripView />} />
      <Route
        path={Locations.EmployeeLeaderboards.Overview}
        element={<LeaderboardsOverviewView />}
      />
      <Route
        path={Locations.EmployeeOptIn.Overview}
        element={<EmployeeOptInOverviewView />}
      />
      <Route
        path={Locations.EmployeeReimbursement.Overview}
        element={<ReimbursementView />}
      />
      <Route
        path={Locations.EmployeeTransitPass.Overview}
        element={<TransitPassOverviewView />}
      />
      <Route
        path={Locations.EmployeeReportedUsage}
        element={<ReportedUsageView />}
      />
      <Route
        path={Locations.EmployeeConcierge}
        element={<EmployeeConciergeView />}
      />
    </Route>
  </>
)

export default EmployeeRoutes
